/**
 * 大屏运行时配置。
 *
 * 构建期注入（vue-cli 只暴露 VUE_APP_*，所以 vue.config.js 里用 DefinePlugin
 * 额外定义了 VITE_* 两个键，见 vue.config.js）：
 *   VITE_DASHBOARD_API   聚合接口 base（默认 https://api.heysen.io/admin-api）
 *   VITE_DASHBOARD_TOKEN 管理端 JWT（P0 临时方案；真值只进 .env.local，不进 git）
 *
 * 注意：这两个表达式必须整段书写，DefinePlugin 只做字面替换。
 */
export const API_BASE = (
  process.env.VITE_DASHBOARD_API || 'https://api.heysen.io/admin-api'
).replace(/\/+$/, '')

export const DASHBOARD_TOKEN = process.env.VITE_DASHBOARD_TOKEN || ''

export const REFRESH_INTERVAL_MS = 5 * 60 * 1000
